import type { BasisPayload } from '../api/types';
import { apiTable, BASIS_HEADS, BASIS_INTRO, snapshotTable, type BasisTableModel } from '../lib/basisTable';
import type { Snapshot } from '../lib/snapshot';

function Pct({ v }: { v: number | null | undefined }) {
  if (v == null || !Number.isFinite(v)) return <td className="num">n/a</td>;
  return <td className={`num ${v >= 0 ? 'pos' : 'neg'}`}>{v >= 0 ? '+' : ''}{v.toFixed(2)}</td>;
}

export interface GapProps {
  snapshot: Snapshot | null;
  basis: BasisPayload | null;
  /** The note appended to the snapshot intro when the live table is not shown. */
  fallbackNote: string | null;
}

export function Gap({ snapshot, basis, fallbackNote }: GapProps) {
  let model: BasisTableModel | null = null;
  if (basis) {
    const t = apiTable(basis);
    if ('empty' in t) { if (snapshot) model = snapshotTable(snapshot, t.note(snapshot)); }
    else model = t;
  } else if (snapshot) {
    model = snapshotTable(snapshot, fallbackNote);
  }
  return (
    <section className="section" id="gap">
      <h2>What happens while the bell is silent</h2>
      <div className="cols">
        <p>Chainlink's Stock Token feeds on Robinhood Chain follow Robinhood's 24 hour session, not the NYSE cash session. They can update from Sunday 20:00 ET to Friday 20:00 ET and have no heartbeat from Friday 20:00 ET to Sunday 20:00 ET or through a US market holiday; after a holiday the overnight session starts at 20:00 ET on the holiday itself. On Monday 7 September 2026, Labor Day, we measured 35 feeds, all between 2.6 and 2.8 days old; they resumed that evening at 20:00 ET, 00:00 UTC on Tuesday.</p>
        <p>The pools do not stop. Uniswap keeps quoting the tokens all weekend. Liquidity providers in those pools earn the same fee at 3 a.m. on Sunday as at 10 a.m. on Tuesday, while the newest price anyone can check is two or three days old.</p>
        <p>The gap is usually small and sometimes not. On 30 August 2026 the HIMS token traded 112 percent above its frozen feed after one memecoin pool had collected about 81 percent of the tokens in circulation on chain. The feed caught up on Monday. The liquidity providers paid for the weekend.</p>
      </div>

      <h3>Measured this weekend</h3>
      <p className="table-intro" id="basis-intro">{model ? model.intro : BASIS_INTRO}</p>
      <div className="table-scroll">
        <table className="basis" id="basis-table">
          <thead><tr><th>Token</th><th>{model ? model.heads[0] : BASIS_HEADS[0]}</th><th>{model ? model.heads[1] : BASIS_HEADS[1]}</th><th>Pool liquidity</th><th>Feed last moved</th></tr></thead>
          <tbody>
            {model?.rows.map((r) => (
              <tr key={r.key}><td>{r.sym}</td><Pct v={r.first} /><Pct v={r.last} /><td className="num">{r.liquidity}</td><td>{r.moved}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
